var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-tab"},[_c('div',{staticClass:"tab-list"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.id,class:{activeClass:_vm.aim == item.id},on:{"click":function($event){return _vm.clickTab(item.id, item.name)}}},[_vm._v(_vm._s(item.name))])}),0),_vm._v(" "),_c('div',{staticClass:"divide"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68748df0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab.vue
// module id = null
// module chunks = 